import { LocalStorageService } from '.';

const KEY_NAME = 'appointment';

const appointmentLocalStorageService = new LocalStorageService(KEY_NAME);

export { appointmentLocalStorageService };
